export default __webpack_public_path__ + "f05e115cd6a275e8a976a3682a0c8f67.png";